import styled from 'styled-components';

export const PlayGrid = styled.div`
  width: 100%;
  height: 100%;

  .data-grid-highlight.selection {
    z-index: 2;
  }
`;

export const LoaderWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
